import { initialState } from './stock-count.model';
import * as actions from './stock-count.actions';
import * as customerActions from 'app/core/store/session/selected-customer/select-customer.actions';
import { StockCountState } from './stock-count.interface';

// let filterValuesLoadedCounter = 0;

export function reducer(state: StockCountState = initialState, action: actions.Actions | customerActions.Actions): StockCountState {
  switch (action.type) {
    // FILTER
    case actions.STOCK_COUNTS_FILTER_VALUES_LOAD: {
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload,
        },
        stockCounts: {
          ...initialState.stockCounts,
          loading: true,
        }
      };
    }

    // STOCK COUNT LIST
    case actions.STOCK_COUNTS_FILTER_VALUES_LOAD_SUCCESS: {
      return {
        ...state,
        stockCounts: {
          ...initialState.stockCounts,
          loadSuccess: true,
          data: action.payload,
        },
      };
    }

    case actions.STOCK_COUNTS_FILTER_VALUES_LOAD_FAIL: {
      return {
        ...state,
        stockCounts: {
          ...initialState.stockCounts,
          loadFailed: true,
        },
      };
    }

    case actions.STOCK_COUNTS_PAGE_NUMBER_UPDATE: {
      return {
        ...state,
        filter: {
          ...state.filter,
          pageNumber: action.payload,
        },
      };
    }

    case actions.STOCK_COUNTS_PAGE_SIZE_UPDATE: {
      return {
        ...state,
        filter: {
          ...state.filter,
          pageSize: action.payload,
        },
      };
    }

    case actions.STOCK_COUNTS_DETAIL_LOAD:
      return {
        ...state,
        detail: {
          ...initialState.detail,
          loading: true,
        }
      }

    case actions.STOCK_COUNTS_DETAIL_LOAD_SUCCESS: {
      return {
        ...state,
        detail: {
          ...initialState.detail,
          loadSuccess: true,
          data: {
            ...action.payload,
            orders: action.payload.orders.filter(o => !!o), // filter out null values
            items: action.payload.items.filter(i => !!i), // filter out null values
          },
        },
      };
    }

    case actions.STOCK_COUNTS_DETAIL_LOAD_FAIL:
      return {
        ...state,
        detail: {
          ...initialState.detail,
          loadFailed: true,
          errorMessage: action.payload,
        }
      }


    case actions.STOCK_COUNTS_ORDER_LIST_LOAD: {
      return {
        ...state,
        orders: null,
        materials: null,
      };
    }

    case actions.STOCK_COUNTS_ORDER_LIST_LOAD_SUCCESS: {
      return {
        ...state,
        orders: action.payload.orders,
      };
    }

    case actions.STOCK_COUNTS_MATERIAL_LIST_LOAD_SUCCESS: {
      return {
        ...state,
        materials: action.payload,
      };
    }

    case actions.STOCK_COUNTS_SHIPTO_LOAD: {
      return {
        ...state,
        shipTos: {
          loadSuccess: false,
          loading: true,
          loadFailed: false,
          data: null,
        },
      };
    }
    case actions.STOCK_COUNTS_SHIPTO_LOAD_FAIL: {
      return {
        ...state,
        shipTos: {
          loadSuccess: false,
          loading: false,
          loadFailed: true,
          data: null,
          errorMessage: action.payload,
        },
      };
    }

    case actions.STOCK_COUNTS_SHIPTO_LOAD_SUCCESS: {
      return {
        ...state,
        shipTos: {
          data: action.payload,
          loadFailed: false,
          loading: false,
          loadSuccess: true,
        },
      };
    }

    case actions.STOCK_COUNTS_CREATE_CANCELED: {
      return {
        ...state,
        orders: null,
        materials: null,
      };
    }

    case customerActions.CLEAR_SELECTED_CUSTOMER: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
